import React from "react";
import { hydrateRoot, createRoot } from "react-dom/client";
import "animate.css";
import "bootstrap/dist/css/bootstrap.css";

import "../../common/base.scss";

import { Main } from "./main";
import { SSRDataProvider } from "../../providers/ssr-data-provider";

const container = document.querySelector("#root");
// hydrateRoot(
//   container,
//   <SSRDataProvider value={{ pathname: location.pathname }}>
//     <Main />
//   </SSRDataProvider>
// );
const root = createRoot(container);
root.render(
  <SSRDataProvider value={{ pathname: location.pathname }}>
    <Main />
  </SSRDataProvider>
);
